export {
  getAttributeSelectors,
  getCurrentAttributeSelectorValues,
  getVariantAttrData,
  type AttributeSelector
} from './attribute-selector'
export * from './classes'
export { COLOR_PROPERTY, MAX_COLORS_PER_VIEW } from './color'
export { getColorSelector } from './color-variants'
export {
  filterHistoryByStash,
  getEnabledFilters,
  getHistoryFromStash,
  getMatchedVariant,
  showProduct,
  type EnabledFiltersType,
  type FilterStashType,
  type HistoryFilter
} from './filter'
export { getFlavourProfiles } from './flavour-profiles'
export {
  buildMultibuySelectItems,
  getMultibuyDefaultValue,
  getMultibuyPriceForCard
} from './multibuy'
export { groupBy, productMapper, ProductProperties } from './group-by'
export { getPriceInfo } from '../../common/price-info'
export {
  SORT_PARAM_KEY,
  OrderEnum,
  sortFilterOptions,
  sortItemsByPrice,
  sortItemsBySequenceNumber,
  sortVariantsBySequenceNumber,
  sortVariantsByStock,
  type SortOptionsConfig
} from './sort'
export {
  getStockLevelStatus,
  STOCKS_CACHE_MAX_AGE,
  stockStatusMap,
  type Stocks
} from './stock'
export { getReplacementProductCode } from './replacement-product'
export { isEditAutoDeliveryCart } from './edit-auto-delivery'

export const scrollToElementWithOffset = (
  el: HTMLElement | null,
  offset = 0
) => {
  if (el) {
    const topPosition = el.getBoundingClientRect().top
    const offsetTopPosition = topPosition + window.scrollY - offset

    window.scrollTo({
      top: offsetTopPosition,
      behavior: 'smooth'
    })
  }
}
